import { render, staticRenderFns } from "./ChildDeviceItem.vue?vue&type=template&id=3bbcb9a4&scoped=true&"
import script from "./ChildDeviceItem.vue?vue&type=script&lang=js&"
export * from "./ChildDeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./ChildDeviceItem.vue?vue&type=style&index=0&id=3bbcb9a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbcb9a4",
  null
  
)

export default component.exports